import { DrillthroughTableInjectableRow } from 'common/components/table/drillthrough-table/drillthrough-table.types';
import { MmmCampaignDrilldownModelOutputDto } from '../models/mmm-campaign-drilldown-model-output';
import {
  createCostCell,
  createCpaCell,
  createFieldCell,
  createRevenueCell,
  createRoasCell,
  createSaleCell
} from 'features/advanced-reports/table/advanced-reports-column-defs';
import { MetricTypes } from 'common/constants/metric-types';

export const createDrillthroughTableInjectableRow = (
  row: MmmCampaignDrilldownModelOutputDto,
  columnIds: string[]
): DrillthroughTableInjectableRow => {
  const fieldColumnId = 'Channel';
  const visibleCells = [
    {
      columnId: fieldColumnId,
      cellId: `${row.id}_${fieldColumnId}`,
      element: createFieldCell(
        row.field,
        row.id,
        row.hasChildren,
        row.shouldBlurField
      ),
      isBlurred: row.shouldBlurField
    },
    {
      columnId: MetricTypes.COST,
      cellId: `${row.id}_${MetricTypes.COST}`,
      element: createCostCell(
        {
          primaryValue: row.cost,
          compareValue: 0
        },
        'GBP',
        false
      ),
      isBlurred: false
    },
    {
      columnId: MetricTypes.REVENUE_VALUES,
      cellId: `${row.id}_${MetricTypes.REVENUE_VALUES}`,
      element: createRevenueCell(
        {
          primaryValue: row.revenue,
          compareValue: 0
        },
        'GBP',
        false
      ),
      isBlurred: false
    },
    {
      columnId: MetricTypes.ROAS,
      cellId: `${row.id}_${MetricTypes.ROAS}`,
      element: createRoasCell(
        {
          primaryValue: row.roas ?? 0,
          compareValue: 0
        },
        false
      ),
      isBlurred: false
    },
    {
      columnId: 'MROAS',
      cellId: `${row.id}_MROAS`,
      element: createRoasCell(
        {
          primaryValue: row.mROAS ?? 0,
          compareValue: 0
        },
        false
      ),
      isBlurred: false
    },
    {
      columnId: 'BlendedMMMROAS',
      cellId: `${row.id}_BlendedMMMROAS`,
      element: createRoasCell(
        {
          primaryValue: row.blendedMMMROAS,
          compareValue: 0
        },
        false
      ),
      isBlurred: false
    },
    {
      columnId: 'PlannedSpend',
      cellId: `${row.id}_PlannedSpend`,
      element: createCostCell(
        {
          primaryValue: row.plannedSpend,
          compareValue: 0
        },
        'GBP',
        false
      ),
      isBlurred: false
    },
    {
      columnId: 'EstimatedRevenue',
      cellId: `${row.id}_EstimatedRevenue`,
      element: createRevenueCell(
        {
          primaryValue: row.estimatedRevenue,
          compareValue: 0
        },
        'GBP',
        false
      ),
      isBlurred: false
    },
    {
      columnId: 'EstimatedSales',
      cellId: `${row.id}_EstimatedSales`,
      element: createSaleCell(
        {
          primaryValue: row.estimatedSales,
          compareValue: 0
        },
        false
      ),
      isBlurred: false
    },
    {
      columnId: 'CPA',
      cellId: `${row.id}_CPA`,
      element: createCpaCell(
        {
          primaryValue: row.cpa,
          compareValue: 0
        },
        'GBP',
        false
      ),
      isBlurred: false
    }
  ].filter((cell) => columnIds.includes(cell.columnId));

  const drillthroughRow: DrillthroughTableInjectableRow = {
    rowId: row.id,
    parentId: row.parentId,
    hasChildren: row.hasChildren,
    depth: row.depth,
    cells: visibleCells
  };

  return drillthroughRow;
};
